import styled from 'styled-components'
import { colours } from '@qflow/theme'

import { ColourButton } from 'portal/lib/primitives'
import { DesignMatchRowState } from 'portal/store/designMatches/types'

export const STATE_LABELS: Record<DesignMatchRowState, string> = {
  open: 'Open',
  closed: 'Closed'
}

const STATE_COLOURS: Record<
  DesignMatchRowState,
  { background: string; text: string }
> = {
  open: {
    background: colours.CONSTRUCTION_ORANGE_BACKGROUND,
    text: colours.ORANGE_TEXT
  },
  closed: { background: colours.PALE_GREEN, text: colours.SUCCESS }
}

export const StateTag = styled.span<{ $state: DesignMatchRowState }>`
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.125rem 0.625rem;
  font-weight: 500;
  background-color: ${({ $state }) => STATE_COLOURS[$state]?.background};
  color: ${({ $state }) => STATE_COLOURS[$state]?.text};
`

export const TableWrapper = styled.div`
  background-color: ${colours.WHITE};
  border-radius: 10px;
  padding: 0.5rem 1.25rem 1.25rem 1.25rem;
  margin-top: 1rem;
  box-shadow: 0px 1px 3px 0px #00000026;

  .ant-table-wrapper .ant-table .ant-table-footer {
    padding: 0;
  }
`
export const TableFooter = styled.div`
  position: relative;
  width: 99%;
`
export const ZeroRecordsFooter = styled.div`
  display: flex;
  justify-content: center;
  color: ${colours.BATTLESHIP_GREY};
`
export const ButtonContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0.75rem;
`
export const BTTButton = styled(ColourButton.Basic)`
  line-height: 1;
  width: auto;
`

export const ShowingRecordsText = styled.div`
  margin: 1rem 0.5rem 0;
  text-align: center;
`

export const ResetFilters = styled.button`
  height: 32px;
  width: 22px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border: none;
  background-color: transparent;

  &:disabled {
    cursor: not-allowed;
    color: ${colours.BATTLESHIP_GREY};
  }
`
